"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JobSeekers() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="job-seekers" className="dark bg-background text-foreground py-20 px-6 md:px-8 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        
        {}
        <div ref={contentRef} className={`transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <Card className="bg-card border-none shadow-2xl rounded-2xl overflow-hidden">
            <CardContent className="p-8 md:p-12 flex flex-col gap-6">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight">
                Job Seekers
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
                Manage your profile and search for local caregiving jobs
              </p>
              <div className="pt-4">
                <Button asChild variant="ghost" className="text-primary hover:text-primary/80 hover:bg-transparent p-0 h-auto text-lg font-semibold flex items-center gap-2 justify-start">
                  <Link to="#">
                    Account Login <ArrowRight className="size-5 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        {}
        <div ref={imageRef} className={`transition-all duration-1000 ease-out delay-200 ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
          <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-[4/5]">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent mix-blend-overlay z-10 pointer-events-none"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572459/img/caregiver_smiling_emotive.png" alt="Smiling caregiver looking at the camera" className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105" />
          </div>
        </div>

      </div>
    </section>;
}